module.exports = __webpack_public_path__ + "static/media/fly0082.50edeab3.webp";